import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/one.png'
import _imports_1 from '../assets/images/two.png'
import _imports_2 from '../assets/images/three.png'
import _imports_3 from '../assets/images/four.png'


const _hoisted_1 = {
  id: "home",
  class: "h100 d-flex align-items-center bg-gradient2 -padding"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center text-center" }
const _hoisted_4 = { class: "col-sm-12 col-lg-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Nuestro compromiso es encontrar una oferta para todos ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle text-white max700 mb-3" }, " Haz clic en el botón, contesta las preguntas, y te mostraremos los productos financieros perfectos para ti ", -1)
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-sm-6 col-lg-5 card-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 font-weight-bold mb-0" }, " Todos reciben oferta ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check-alt fa-3x card-i-header" }, null, -1)
const _hoisted_12 = {
  id: "work",
  class: "section-padding d-flex align-items-center h100"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mb-5 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "text-red font-weight-bold" }, "Cómo funciona")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-lg-3 wow fadeIn",
    "data-wow-delay": "0.2s"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row row-steps" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-4 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "max60 mb-3",
          src: _imports_0,
          alt: "paso 1"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-8 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold text-uppercase text-red" }, "Paso 1"),
        /*#__PURE__*/_createTextVNode(" Elige la opción que deseas ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-lg-3 wow fadeIn",
    "data-wow-delay": "0.8s"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row row-steps" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-4 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "max60 mb-3",
          src: _imports_1,
          alt: "paso 2"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-8 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold text-uppercase text-red" }, "Paso 2"),
        /*#__PURE__*/_createTextVNode(" Contesta las preguntas, te tomará 90 segundos ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-lg-3 wow fadeIn",
    "data-wow-delay": "1.3s"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row row-steps" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-4 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "max60 mb-3",
          src: _imports_2,
          alt: "paso 3"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-8 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold text-uppercase text-red" }, "Paso 3"),
        /*#__PURE__*/_createTextVNode(" Al finalizar, te mostraremos las opciones en las que podrías ser aprobado ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-lg-3 wow fadeIn",
    "data-wow-delay": "1.9s"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row row-steps" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-4 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "max60 mb-3",
          src: _imports_3,
          alt: "paso 4"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-8 col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold text-uppercase text-red" }, "Paso 4"),
        /*#__PURE__*/_createTextVNode(" Haz clic en la opción que deseas, y completa el cuestionario ")
      ])
    ])
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row justify-content-center" }
const _hoisted_18 = { class: "col col-sm-5 col-lg-3 text-center mt-4" }
const _hoisted_19 = {
  id: "benefits",
  class: "section-padding d-flex align-items-center h100 bg-gray-200"
}
const _hoisted_20 = { class: "container" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mb-5 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold text-red" }, "Beneficios")
  ])
], -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe-americas card-i" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Desde cualquier lugar")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("El proceso es 100% por internet ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-handshake card-i" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Somos tu aliado")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Te acercamos al prestamista que más te conviene")
const _hoisted_33 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-invoice-dollar card-i" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Proceso personalizado")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Aplica una vez y obtén muchas opciones")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shield-alt card-i" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Seguridad Total")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Sin fraudes, sin depósitos, sin miedo")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-medal card-i" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("100% confiable")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Solo trabajamos con empresas serias y reguladas")
const _hoisted_49 = { class: "col-sm-6 col-lg-4 col-md-6 card-container" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up card-i" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Servicio de calidad")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Todos nuestros usuarios reciben una oferta")
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = { class: "row justify-content-center" }
const _hoisted_57 = { class: "col col-sm-5 col-lg-3 text-center mt-4" }
const _hoisted_58 = { class: "row justify-content-center mt-5 px-4" }
const _hoisted_59 = { class: "text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Card, null, {
                  header: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  title: _withCtx(() => [
                    _hoisted_11
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_Button, {
                      onClick: _ctx.go,
                      label: "Quiero mi oferta",
                      class: "bg-yellow-500 border-yellow-500 p-button-raised p-button-rounded font-weight-bold text-900"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Button, {
              onClick: _ctx.go,
              label: "Quiero mi oferta",
              class: "p-button-raised p-button-rounded font-weight-bold text-white text-900"
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_24
              ]),
              title: _withCtx(() => [
                _hoisted_25
              ]),
              content: _withCtx(() => [
                _hoisted_26,
                _hoisted_27,
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_30
              ]),
              title: _withCtx(() => [
                _hoisted_31
              ]),
              content: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_34
              ]),
              title: _withCtx(() => [
                _hoisted_35
              ]),
              content: _withCtx(() => [
                _hoisted_36,
                _hoisted_37,
                _hoisted_38
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_40
              ]),
              title: _withCtx(() => [
                _hoisted_41
              ]),
              content: _withCtx(() => [
                _hoisted_42,
                _hoisted_43,
                _hoisted_44
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_46
              ]),
              title: _withCtx(() => [
                _hoisted_47
              ]),
              content: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_Card, null, {
              header: _withCtx(() => [
                _hoisted_50
              ]),
              title: _withCtx(() => [
                _hoisted_51
              ]),
              content: _withCtx(() => [
                _hoisted_52,
                _hoisted_53,
                _hoisted_54
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_Button, {
              onClick: _ctx.go,
              label: "Ir al cuestionario",
              class: "p-button-raised p-button-rounded font-weight-bold text-white text-900"
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.name) + " no es un prestamista y no hace préstamos ni toma decisiones de crédito en relación con su servicio de búsqueda de préstamo. " + _toDisplayString(_ctx.name) + " no garantiza la aceptación en un programa de préstamo en particular ni establece las condiciones de los préstamos específicos con cualquier prestamista participante. " + _toDisplayString(_ctx.name) + " tampoco garantiza que el precio, los productos, disponibilidad, tarifas, tasas u otros términos de préstamos ofrecidos y puestos a disposición por los prestamistas participantes, sean las mejores condiciones disponibles en el mercado.Cuando una entidad financiera le otorgue un crédito en cualquiera de sus modalidades, será esta institución quien establezca las condiciones de cada producto financiero, dentro de las cuales se considerarán las siguientes: el monto,el plazo, la tasa de interés normal y moratoria, las cuotas y comisiones, tanto de apertura de crédito como las recurrentes; pudiendo usted aceptar o declinar la oferta respectiva bajo dichas condiciones. Consecuentemente usted pagará por el crédito, el principal o monto del crédito, los intereses, el IVA, las comisiones, gastos y seguros, en su caso; los cuales pueden realizarse en un solo pago al vencimiento o en varios pagos periódicos, al inicio o en cualquier momento durante la vigencia del crédito. Teniendo en cuenta que, dentro de los préstamos personales los productos más solicitados son los denominados créditos al consumo, a continuación se muestra un ejemplo representativo del costo total del préstamo: Monto del Préstamo: Q4,307.00 Plazo en el que se realiza el pago: 3 años (36 pagos mensuales como plazo máximo), Pago mensual nivelado: Q252.00 Total de Pagos Realizados: Q9072 (2.1 veces lo que debes), tasa integrada anual: 66.70%. ", 1)
        ])
      ])
    ])
  ]))
}